export default __webpack_public_path__ + "static/media/download.f92b2ea8.svg";